export const GLOBAL_ERRORS_HANDLED_IN_SENTRY = ['INVALID_ACCESS_TOKEN_ERROR'] as const;
export const GLOBAL_ERRORS_HANDLED_IN_APP = ['THROTTLING_ERROR', 'UPDATE_REQUIRED_ERROR'] as const;
export const GLOBAL_ERRORS = [...GLOBAL_ERRORS_HANDLED_IN_SENTRY, ...GLOBAL_ERRORS_HANDLED_IN_APP] as const;
